// extracted by mini-css-extract-plugin
export default {"imagesContainer":"WebsiteScreenshots_imagesContainer__sAV1d","image":"WebsiteScreenshots_image__klfem"};